/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IPasswordResetSlice {
  isShowPasswordResetModal: boolean;
  activePasswordResetModal: 'passwordResetModal' | 'responseModal' | '';
}

const initialState: IPasswordResetSlice = {
  isShowPasswordResetModal: false,
  activePasswordResetModal: ''
};

export const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState,
  reducers: {
    setIsShowPasswordResetModal: (state: IPasswordResetSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowPasswordResetModal = payload;
    },
    setActivePasswordResetModal: (
      state: IPasswordResetSlice,
      action: PayloadAction<'passwordResetModal' | 'responseModal' | ''>
    ) => {
      const { payload } = action;
      state.activePasswordResetModal = payload;
    }
  }
});

const { actions, reducer } = passwordResetSlice;

export const { setIsShowPasswordResetModal, setActivePasswordResetModal } = actions;

export default reducer;
